import React from 'react'
import Spinner from 'react-bootstrap/Spinner';
function SceenLoader() {
    return (
        <div className='scrn_loader text-center'>
            <Spinner animation="border" variant="light" />
        </div>
    )
}

export default SceenLoader;